import React from 'react';
import { BookOpenIcon, FilterIcon, CalculatorIcon, ShieldIcon, CheckSquareIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-6 h-6 text-brand-gold" data-id="element-115" />,
    title: 'El Método Anti-Tipster (PDF)',
    description: 'La guía paso a paso para construir tu propio criterio analítico.'
  }, {
    icon: <FilterIcon className="w-6 h-6 text-brand-gold" data-id="element-116" />,
    title: 'El Protocolo de Confirmación de 5 Pasos',
    description: 'El filtro exacto que debe pasar un partido antes de invertir un solo dólar.'
  }, {
    icon: <CalculatorIcon className="w-6 h-6 text-brand-gold" data-id="element-117" />,
    title: 'Calculadora de Probabilidad Implícita',
    description: 'Para saber si una cuota es un regalo o una trampa.'
  }, {
    icon: <ShieldIcon className="w-6 h-6 text-brand-gold" data-id="element-118" />,
    title: 'Guía de Gestión de Guerra',
    description: 'Cómo dividir tu capital en unidades para que nunca vuelvas a quemar una cuenta.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6 text-brand-gold" data-id="element-119" />,
    title: 'Checklist Pre-Partido',
    description: 'La lista de verificación que usan los profesionales antes de operar.'
  }];
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <h2 className="text-3xl md:text-4xl text-center text-brand-text mb-12" data-id="element-122">
          Lo que obtienes hoy:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-123">
          {items.map((item, index) => <div key={index} className={`bg-brand-card border border-brand-gold/10 rounded-xl p-6 flex items-start gap-4 hover:border-brand-gold/30 transition-colors ${index === items.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-124">
              <div className="p-3 bg-brand-bg rounded-lg border border-brand-gold/20 shrink-0" data-id="element-125">
                {item.icon}
              </div>
              <div data-id="element-126">
                <h3 className="text-xl text-brand-text mb-2" data-id="element-127">{item.title}</h3>
                <p className="text-brand-muted" data-id="element-128">{item.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}